import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3, FiEye } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";

const MemberTable = () => {
  const navigate = useNavigate();
  const [memberList, setMemberList] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchmemberList = async () => {
 const formData = new FormData();
const IsAdmin = localStorage.getItem("IsAdmin"); // get 'yes' or 'no'
const userId = localStorage.getItem("userId");

if (IsAdmin === "yes") {
  // Admin login
  formData.append("adminId", 1);
 
} else if (IsAdmin === "no") {
  // User login
  formData.append("userId", 1);

}

    const result = await fetchFormData("member/list", formData, "POST");

    if (result) {
      const list = result.data || [];
      // list.sort((a, b) => {
      //   const nameA = a.full_name || "";
      //   const nameB = b.full_name || "";
      //   return nameA.localeCompare(nameB);
      // });

      setMemberList(list);
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("id", Id);

    const result = await fetchFormData(
      "member/toggle-status",
      formData,
      "POST"
    );

    if (result && result.code === 200) {
      fetchmemberList();
      if (result?.status === 1) {
        topTost({
          title: "Status updated successfully: Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully: Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle member status:", result?.message);
    }
  };

  const columns = [
    {
      accessorKey: "actions",
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.id;
        const is_active = row.original.status;
        return (
          <div className="hstack gap-2 justify-content-end">
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/member/edit-member/${id}`)}
            >
              <FiEdit3 size={16} />
            </span>
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/member/view-member/${id}`)}
            >
              <FiEye size={16} />
            </span>

            {is_active === 1 ? (
              <MdThumbUp
                className="cursor-pointer text-success"
                onClick={() => toggleStatus(id)}
              />
            ) : (
              <MdThumbDown
                className="cursor-pointer text-secondary"
                onClick={() => toggleStatus(id)}
              />
            )}
          </div>
        );
      },
      meta: {
        headerClassName: "width-30",
        exportable: false,
      },
    },

    {
      accessorKey: "aadhaar_no",
      header: () => "Aadhaar No",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "aadhaar_photo",
      header: () => "Aadhaar Photo",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "address_proof_photo",
      header: () => "Address Proof Photo",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "alternate_phone",
      header: () => "Alternate Phone",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "annual_income",
      header: () => "Annual Income",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "branch_id",
      header: () => "Branch ID",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "branch_name",
      header: () => "Branch Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "cibil_report_date",
      header: () => "CIBIL Report Date",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "cibil_score",
      header: () => "CIBIL Score",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "created_at",
      header: () => "Created At",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "created_by",
      header: () => "Created By",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "current_address",
      header: () => "Current Address",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "current_city",
      header: () => "Current City",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "current_district",
      header: () => "Current District",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "current_pincode",
      header: () => "Current Pincode",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "current_state",
      header: () => "Current State",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "dob",
      header: () => "Date of Birth",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "email",
      header: () => "Email",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "full_name",
      header: () => "Full Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "gender",
      header: () => "Gender",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "id",
      header: () => "ID",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "is_aadhaar_verified",
      header: () => "Aadhaar Verified",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "is_pan_verified",
      header: () => "PAN Verified",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "marital_status",
      header: () => "Marital Status",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "member_code",
      header: () => "Member Code",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "mobile",
      header: () => "Mobile",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "name",
      header: () => "Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "nominee_name",
      header: () => "Nominee Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "nominee_phone",
      header: () => "Nominee Phone",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "nominee_relation",
      header: () => "Nominee Relation",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "notes",
      header: () => "Notes",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "occupation",
      header: () => "Occupation",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "pan_no",
      header: () => "PAN No",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "pan_photo",
      header: () => "PAN Photo",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "permanent_address",
      header: () => "Permanent Address",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "permanent_city",
      header: () => "Permanent City",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "permanent_district",
      header: () => "Permanent District",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "permanent_pincode",
      header: () => "Permanent Pincode",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "permanent_state",
      header: () => "Permanent State",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "photo",
      header: () => "Photo",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "registered_at",
      header: () => "Registered At",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "remarks",
      header: () => "Remarks",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "updated_at",
      header: () => "Updated At",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    // {
    //   accessorKey: "status",
    //   header: () => "Status",
    //   cell: ({ getValue }) => (getValue() === 1 ? "Active" : "Inactive"),
    // },
  ];

  useEffect(() => {
    fetchmemberList();
  }, []);
  return (
    <>
      <Table data={memberList} columns={columns} />
    </>
  );
};

export default MemberTable;
